import { VAT_PREFERENCE } from 'src/features/VatPreferenceSlice'

/** '(inc VAT)' / '(ex VAT)' — append to labels so the mode is always explicit. */
export const vatLabelSuffix = preference =>
  preference === VAT_PREFERENCE.INC ? '(inc VAT)' : '(ex VAT)'

/** Column/chart header label, e.g. 'Spend on OMS (inc VAT)'. */
export const withVatLabel = (label, preference) =>
  `${label} ${vatLabelSuffix(preference)}`

const toFinite = value => {
  const num = Number(value)
  return Number.isFinite(num) ? num : 0
}

/**
 * Pick the spend figure matching the preference from an ex/inc pair.
 * Falls back to the ex figure when inc is missing (older API payloads),
 * so a not-yet-deployed backend never blanks a screen.
 */
export const pickVatTotal = (preference, { exVat, incVat } = {}) =>
  preference === VAT_PREFERENCE.INC && Number.isFinite(Number(incVat))
    ? toFinite(incVat)
    : toFinite(exVat)

/**
 * Spend Over Time rows: pick `totalAmountIncVat` when inc VAT is selected,
 * falling back to `totalAmount` when the field is absent.
 */
export const pickSpendOverTimeAmount = (preference, row = {}) =>
  preference === VAT_PREFERENCE.INC
    ? pickVatTotal(preference, {
        exVat: row.totalAmount,
        incVat: row.totalAmountIncVat,
      })
    : toFinite(row.totalAmount)

/**
 * Gross Profit per-day rows: pick `purchasesOnOMSIncVat` when inc VAT is
 * selected, falling back to `purchasesOnOMS` when the field is absent.
 */
export const pickGpOmsSpend = (preference, day = {}) =>
  preference === VAT_PREFERENCE.INC
    ? pickVatTotal(preference, {
        exVat: day.purchasesOnOMS,
        incVat: day.purchasesOnOMSIncVat,
      })
    : toFinite(day.purchasesOnOMS)
